<template>
  <div :spinning="loading">
    <p class="title">选择参赛组别</p>
    <div class="contentWarp">
      <template v-for="(item, index) in combatList">
        <div
          v-if="combatList.length > 0"
          :class="choiceCombat != null && choiceCombat.name === item.name ? 'childred check' : 'childred default'"
          :key="index"
          @click="clickCombat(item)">
          {{ item.name }}
        </div>
      </template>
      <a-alert type="warning" v-if="combatList.length === 0" style="width:100%;">
        <div style="margin: 0 auto;" slot="description" v-if="!loading">
          <a-empty :image="simpleImage">
            <span slot="description">暂无项目信息</span>
          </a-empty>
        </div>
      </a-alert>
      <a-alert
        class="ageAlert"
        v-if="choiceCombat != null"
        :message="'该组别年龄限制范围：' + matchFun.formatDate(choiceCombat.minAge) + ' ~ ' + matchFun.formatDate(choiceCombat.maxAge)"
        banner/>
    </div>
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import { Empty } from 'ant-design-vue'
export default {
  data () {
    return {
      loading: false,
      combatList: [],
      choiceCombat: null,
      matchFun: matchFun,
      matchId: this.$route.query.matchId,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
    }
  },
  mounted () {
    this.loading = true
    this.$api.match.queryCombatDetailGroup(this.matchId).then(res => {
      if (res.status === 0) {
        this.combatList = res.data
      } else {
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.log('err', err)
      this.$message.error('项目获取失败')
    }).finally(_ => {
      this.loading = false
    })
  },
  methods: {
    clickCombat (record) {
      if (this.choiceCombat == null || this.choiceCombat.name != record.name) {
        this.choiceCombat = record
        this.$emit('clickCombat', this.choiceCombat)
      } else {
        this.choiceCombat = record
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    font-size: 19px;
    font-weight: bold;
  }
  .contentWarp{
    display: flex;
    flex-wrap: wrap;
  }
  .childred {
    min-width: 100px;
    min-height: 40px;
    margin-right:20px;
    margin-bottom: 5px;
    text-align: center;
    line-height: 40px;
    padding-left:10px;
    padding-right: 10px;
    cursor: pointer;
  }
  .default {
    background-color: #fff;
    color: black;
    border: 1px solid #dbdbdb;
  }
  .check {
    background-color: #b80000;
    color: white;
    border: 1px solid #b80000;
  }
  .ageAlert {
    width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/StepThreeCombat.vue